'use client'
import clsx from 'clsx'
import { forwardRef, useEffect, useState, type HTMLAttributes } from 'react'
import { Toast } from './toast'
import { useToaster, type ToastData } from './toasts-context'

type ToasterProps = HTMLAttributes<HTMLDivElement>

const Toaster = forwardRef<HTMLDivElement, ToasterProps>((props, ref) => {
    const { className, ...otherProps } = props
    const [toasts, setToasts] = useState<ToastData[]>([])

    const { subscribe, remove } = useToaster()

    useEffect(() => {
        const { unsubscribe } = subscribe(setToasts)
        return () => {
            unsubscribe()
        }
    }, [subscribe])

    return (
        <div
            style={{ bottom: 70 }}
            ref={ref}
            className={clsx(
                'pointer-events-none fixed bottom-0 left-0 right-0 z-[99] flex flex-col items-center overflow-hidden lg:items-start',
                className,
            )}
            {...otherProps}
        >
            <div className="flex max-w-xs flex-col items-center lg:items-start">
                {toasts.map(({ content, id, type, variant, timeout }) => (
                    <Toast
                        type={type}
                        variant={variant}
                        key={id}
                        onClose={() => {
                            remove(id)
                        }}
                        duration={timeout}
                    >
                        {content}
                    </Toast>
                ))}
            </div>
        </div>
    )
})

Toaster.displayName = 'Toaster'

export { Toaster, type ToasterProps }
